import { GridCellProps } from '@progress/kendo-react-grid';
import GridCellBase from 'src/components/GridCellBase';
import TextInput from 'src/components/TextInput';
import useDelayedInputOnchange from 'src/hooks/useDelayedInputOnchange';

const UOMCell = (props: GridCellProps) => {
  const { dataItem } = props;
  const { errors = [] } = dataItem;
  const isDisabled = !dataItem.selected;
  const { handleChange, value } = useDelayedInputOnchange(props, true);
  return (
    <GridCellBase {...props} className={'!bg-transparent'} title={value}>
      <div className="flex items-center gap-2">
        <span className="text-black">=</span>
        <div className="w-full">
          <TextInput
            type={'text'}
            value={value}
            placeholder="UOM"
            onChange={handleChange}
            disabled={isDisabled}
            valid={!errors.length}
          />
        </div>
      </div>
    </GridCellBase>
  );
};

export default UOMCell;
